import * as React from 'react';
import styled from 'styled-components';
import {TextValue} from 'api/lesson/types';
import Container from 'containers/Container';
import {Markup} from 'interweave';

export interface TextTemplateProps {
  value: TextValue;
}

const Wrapper = styled.div`
  line-height: 24px;
`;

/**
 * This is the text block of the lesson viewer.
 * @param {TextTemplateProps} props
 * @return {React.ReactElement<TextTemplateProps>}
 * @constructor
 */
export default function TextTemplate(
    props: TextTemplateProps,
): React.ReactElement<TextTemplateProps> {
  return (
    <Container>
      <Wrapper>
        <Markup content={props.value} />
      </Wrapper>
    </Container>
  );
}
